/*
 * Any links added to /docs should be written to work in GitHub (i.e. be in the format of the map keys).
 * If a link will show up in the Storybook docs sidebar, add it to this map.
 * Otherwise the link won't work in Storybook.
 */
export const docLinkMap = {
  'accessibility.md': '?path=/docs/general-accessibility--docs',
  'getting-started.md': '?path=/docs/general-getting-started--docs',
  'grid.md': '?path=/docs/general-grid--docs',
  'layout.md': '?path=/docs/general-layout--docs',
  '../CONTRIBUTING.md': '?path=/docs/general-contributing--docs',
  'docs/accessibility.md': '?path=/docs/general-accessibility--docs',
  'docs/getting-started.md': '?path=/docs/general-getting-started--docs',
  'docs/grid.md': '?path=/docs/general-grid--docs',
  'docs/layout.md': '?path=/docs/general-layout--docs',
  'CONTRIBUTING.md': '?path=/docs/general-contributing--docs',
  'docs/dev/build.md': 'https://github.developer.allianz.io/oneMarketing/elements/blob/master/docs/dev/build.md',
  'docs/dev/continuous-integration.md':
    'https://github.developer.allianz.io/oneMarketing/elements/blob/master/docs/dev/continuous-integration.md',
  'docs/dev/code-review.md':
    'https://github.developer.allianz.io/oneMarketing/elements/blob/master/docs/dev/code-review.md',
  'docs/dev/css-architecture.md':
    'https://github.developer.allianz.io/oneMarketing/elements/blob/master/docs/dev/css-architecture.md',
  'docs/dev/development-guidelines.md':
    'https://github.developer.allianz.io/oneMarketing/elements/blob/master/docs/dev/development-guidelines.md',
  'docs/dev/getting-started.md':
    'https://github.developer.allianz.io/oneMarketing/elements/blob/master/docs/dev/getting-started.md',
  'docs/dev/self-review.md': '?path=/docs/development-self-review--docs',
};
